// Domain types and helpers for the authenticated user. Kept separate from the generic api-client.

import { api } from './api-client';

export type CurrentUser = {
  userId: number;
  workEmail: string;
  displayName: string;
  roleCode: string;
};

export const oauthRedirectUrl = '/oauth2/authorization/google';

export async function signOut(): Promise<void> {
  await api.post('/v1/auth/logout');
}
